import { Node } from "@tiptap/core";

import { ActionButton } from "../../components";

export const Clear = Node.create({
	name: "clear",
	addOptions() {
		return {
			...this.parent?.(),
			button: ({ editor, t }) => ({
				component: ActionButton,
				componentProps: {
					action: () => editor.chain().focus().clearNodes().unsetAllMarks().run(),
					icon: "Eraser",
					tooltip: t("editor.clear.tooltip")
				}
			})
		};
	}
});
